import { NavLink, Outlet } from "react-router-dom";
import { LayoutList, FilePlus2, Users, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/Brand";
import { NotificationBell } from "@/components/admin/NotificationBell";

const links = [
  { to: "/admin", end: true, icon: LayoutList, label: "Comenzi", id: "nav-orders" },
  { to: "/admin/orders/new", icon: FilePlus2, label: "Comandă nouă", id: "nav-new-order" },
  { to: "/admin/drivers", icon: Users, label: "Șoferi", id: "nav-drivers" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="relative z-10 min-h-screen">
      <header className="sticky top-0 z-30 border-b border-white/10 bg-[#0A0E17]/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 sm:px-6">
          <NavLink to="/admin" className="flex items-center gap-3" data-testid="admin-home-link">
            <BrandMark className="h-10" />
            <div className="hidden leading-none sm:block">
              <div className="font-display text-xl font-bold uppercase text-blue-400">M-Line</div>
              <div className="eyebrow mt-0.5">Dispecerat</div>
            </div>
          </NavLink>
          <nav className="ml-2 flex flex-1 gap-1 overflow-x-auto">
            {links.map(({ to, end, icon: Icon, label, id }) => (
              <NavLink key={to} to={to} end={end} data-testid={id}
                className={({ isActive }) => `flex items-center gap-2 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-white/5"}`}>
                <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <span className="hidden text-xs text-slate-500 lg:block">{user?.email}</span>
          <NotificationBell />
          <button onClick={logout} data-testid="admin-logout-btn" className="rounded-full p-2 text-slate-400 transition-colors hover:bg-white/5 hover:text-white" title="Ieșire">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
